module.exports = __webpack_public_path__ + "img/MDI - file-download-outline.13b20cda.svg";